import type { CrossroadsMappingType } from '@/api/types'
import { $api, type InferResponse } from '../typedClient'

type RefDataMapResponse = InferResponse<
  '/crossroads/mappings/ref_data_map',
  'get'
>
export type RefDataMapEntry = RefDataMapResponse[number]

export function useRefDataMap(
  sourceSystem: string | undefined,
  type: CrossroadsMappingType,
) {
  return $api.useQuery(
    'get',
    '/crossroads/mappings/ref_data_map',
    { params: { query: { source_system: sourceSystem!, type } } },
    {
      enabled: !!sourceSystem,
      staleTime: 5 * 60 * 1000,
    },
  )
}
